import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
    selectUpdateNotification,
    setUpdateNotification,
} from '../../../features/notifications/notificationsSlice'
import type { TargetType } from '../../../types/notifications'

const targetOptions: { label: string; value: TargetType }[] = [
    { label: 'All', value: 'all' },
    { label: 'Technicians', value: 'technicians' },
    { label: 'Dispatchers', value: 'dispatcher' },
    { label: 'Executives', value: 'executives' },
    { label: 'Tenant Admin', value: 'tenant_admin' },
    { label: 'Clients', value: 'customer' },
]

const TargetTab: React.FC = () => {
    const dispatch = useDispatch()
    const formState = useSelector(selectUpdateNotification)

    const handleCheckboxChange = (value: string) => {
        const currentTargets = formState.target || []
        let updatedTargets: TargetType[]

        if (value === 'all') {
            updatedTargets = currentTargets.includes(value)
                ? []
                : targetOptions.map((option) => option.value)
        } else {
            updatedTargets = currentTargets.includes(value)
                ? currentTargets.filter((target: string) => target !== value)
                : [...currentTargets, value]

            if (updatedTargets.includes('all') && value !== 'all') {
                updatedTargets = updatedTargets.filter(
                    (target) => target !== 'all',
                )
            }

            if (
                updatedTargets.length === targetOptions.length - 1 &&
                !updatedTargets.includes('all')
            ) {
                updatedTargets.push('all')
            }
        }

        dispatch(setUpdateNotification({ target: updatedTargets }))
    }

    return (
        <form className="custom-form" method="POST">
            <div className="custom-form-body">
                <div className="row gutters-16">
                    <div className="col-12">
                        <div className="form-group--row input--xl items-start">
                            <p className="label">Select target users</p>
                            <ul className="labels-list">
                                {targetOptions.map(({ label, value }) => (
                                    <li key={value} className="label-item">
                                        <label className="custom-checkbox">
                                            <input
                                                type="checkbox"
                                                name="target_users"
                                                checked={
                                                    formState?.target?.includes(
                                                        value,
                                                    ) || false
                                                }
                                                onChange={() =>
                                                    handleCheckboxChange(value)
                                                }
                                                className="custom-checkbox__input"
                                            />
                                            <span className="custom-checkbox__input-fake">
                                                <span className="icon-ico-check"></span>
                                            </span>
                                            <span className="custom-checkbox__label">
                                                {label}
                                            </span>
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default TargetTab
